import NewTable from "components/NewTable";
import useGetSolicitacaoCadastro from "features/SolicitacaoCadastro/hooks/useGetSolicitacaoCadastro";
import useSolicitacaoCadastroColumns from "ui/pages/Admin/Administracao/SolicitacaoCadastro/Listagem/components/useSolicitacaoCadastroColumns";
import HeaderTable from "components/Page/HeaderTable";
import PageHeader from "components/Page/PageHeader";
import { useBreadcrumb } from "features/breadcrumbs";
import history from "infra/helpers/history";
import useAnalisarSolicitacao from "features/SolicitacaoCadastro/hooks/useAnalisarSolicitacao";
import { useLoading } from "components/GlobalLoading";

import { showConfirm } from "infra/helpers/alerta";
import useFiltro from "infra/helpers/useFiltro";
import Container from "components/Container";

function ListagemSolicitacoes() {
  const { mutate: analisarSolicitacao, isLoading: isLoadingAnalisar } =
    useAnalisarSolicitacao();

  const { filtro, setFiltro, onChangeFiltro } = useFiltro();

  const { data, isLoading, isFetching } = useGetSolicitacaoCadastro(filtro);
  const columns = useSolicitacaoCadastroColumns();

  useLoading(isLoadingAnalisar);

  useBreadcrumb([{ name: "Solicitação de cadastro" }]);

  return (
    <div>
      <Container>
        <PageHeader title="Solicitações de cadastro" />

        <NewTable
          title={() => (
            <HeaderTable
              value={filtro.search as any}
              onSearch={(q?: string) =>
                setFiltro((prev: any) => ({
                  ...prev,
                  search: q,
                  page: 1,
                }))
              }
            />
          )}
          onRow={(original) => ({
            style: {
              cursor: "pointer",
            },
            onClick: () => {
              if (!original.pessoaAnalistaId) {
                showConfirm(
                  "Ao acessar essa solicitação você se tornará o responsável pela análise da mesma. Deseja continuar?"
                ).then(({ isConfirmed }) => {
                  if (isConfirmed) {
                    analisarSolicitacao(original.id, {
                      onSuccess: () => {
                        history.push(
                          `/administracao/solicitacao-cadastro/${original.id}`
                        );
                      },
                    });
                  }
                });
              } else {
                history.push(
                  `/administracao/solicitacao-cadastro/${original.id}`
                );
              }
            },
          })}
          loading={isLoading || isFetching}
          columns={columns}
          dataSource={data?.items ?? []}
          customPagination={{
            currentPage: data?.meta.currentPage ?? 0,
            itemsPerPage: data?.meta.itemsPerPage ?? 0,
            totalItems: data?.meta.totalItems ?? 0,
            onChangePage: (page) => {
              onChangeFiltro("page", page);
            },
          }}
        />
      </Container>
    </div>
  );
}

export default ListagemSolicitacoes;
